module.exports = __webpack_public_path__ + "img/12f89a3.png";